import React from 'react';

import { FieldProps } from 'react-final-form';

import Field from './Field';

export default ({ name, ...rest }: FieldProps<any, any>) => (
  <Field name={name} {...rest} type="password" />
);
